$(function() {
    $('.video').mouseenter(function(){
        $(this).parent().css('z-index', 210);
        $(this).parent().find('.videoOverlay').css('z-index', -1);
    }).mouseleave(function(){
        $(this).parent().css('z-index', 0);
        $(this).parent().find('.videoOverlay').css('z-index', 500);
    });
    $('.video .videoOverlay').click(function() {
        $(this).parent().parent().css('z-index', 10);
    })
});
